import { createFileRoute } from "@tanstack/react-router";
import { ErrorPage } from "../../../features/errors";

export const Route = createFileRoute("/$lang/_layout/410")({
  component: () => <ErrorPage status={410} />,
});
